<template>
    <div class="chart_warp">
        <div class="chart_tool">
            <el-button class="def_btn tool_icon_btn" plain size="small" icon="el-icon-full-screen" :disabled="showEmpty" @click="fullScreen">
            </el-button>
        </div>
        <div class="chart_cont" :ref="'radar_' + chartName"></div>
        <!-- 全屏显示图表 -->
        <el-dialog title="综合能力评分图" custom-class="big_dialog" top="0" :visible.sync="fullVisible" width="100%">
            <div class="chart_cont" :ref="'full_radar_' + chartName"></div>
        </el-dialog>
    </div>
</template>

<script>
import { changeNum, formatInt } from '@/api/portrait.js'
export default {
    props: {
        showEmpty: false,
        chartInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            myChart: null,
            fullVisible: false,
            chartName: '',
            dialogTitle: '',
            option: {
                color: ['#6AADB3', '#FF7623'],
                legend: {
                    data: ['均值', '当月值'],
                    top: '10',
                    right: '10',
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 20,
                    textStyle: {
                        color: '#929292',
                    },
                },
                tooltip: {},
                radar: {
                    indicator: [
                        { name: '计划管理', max: 5200 },
                        { name: '时间管理', max: 16000 },
                        { name: '使用频度', max: 30000 },
                        { name: '客户管理', max: 38000 },
                        { name: '质量管理', max: 52000 },
                    ]
                },
                animationDuration: 100,
                animationDurationUpdate: 0,
                series: [
                    {
                        type: 'radar',
                        data: [
                            {
                                value: [],
                                name: '均值',
                                areaStyle: {
                                    color: 'rgba(226,255,248,0.25)'
                                }
                            },
                            {
                                value: [],
                                name: '当月值',
                                areaStyle: {
                                    color: 'rgba(255,178,121,0.25)'
                                }
                            },

                        ]
                    }
                ]
            }
        }
    },
    beforeDestroy() {
        this.myChart && this.myChart.clear()
    },
    methods: {
        setOption(val) {
            let data = val
            this.option.series[0].data[0].value = data.mean
            this.option.series[0].data[1].value = data.power
            let indicator = this.option.radar.indicator.map((item, i) => {
                let numList = [data.mean[i], data.power[i]]
                let max = Math.max.apply(null, numList)
                item.max = formatInt(max, true)
                return item
            })
            this.option.radar.indicator = indicator
            this.$nextTick(() => {
                this.fullVisible ? this.loadChart('full_radar_' + this.chartName) : this.loadChart('radar_' + this.chartName)
            })
        },
        loadChart(chartId) {
            let chartDom = this.$refs[chartId];
            this.myChart = this.$echarts.init(chartDom);
            this.myChart.setOption(this.option);
            this.$nextTick(() => {
                this.myChart.resize();
            })
        },
        fullScreen() {
            this.fullVisible = true
            this.$nextTick(() => {
                this.loadChart('full_radar_' + this.chartName)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.chart_warp {
    width: 100%;
    height: 100%;
    position: relative;
    .chart_tool {
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 1;

        /deep/.el-button {
            position: absolute;
            right: 0;

            &.tool_icon_btn {
                right: unset;
                left: 0;
                padding: 0;
                width: 32px;
                height: 32px;

                i {
                    font-size: 20px;
                }
            }
        }

        &.active {
            display: none;
            transition: all .3s;

            /deep/.el-button {
                border-color: #666;
                color: #666;

                &.tool_icon_btn {
                    width: 24px;
                    height: 24px;

                    i {
                        font-size: 16px;
                    }
                }
            }
        }
    }

    .chart_cont {
        width: 100%;
        height: 100%;
    }

    &:hover {
        .chart_tool.active {
            display: block;
        }
    }
}

/deep/.el-dialog {
    &.big_dialog {
        height: 100%;
        margin: 0;

        .el-dialog__header {
            padding: 10px;
            border-bottom: 1px solid #ddd;

            .el-dialog__headerbtn {
                top: 15px;
            }
        }

        .el-dialog__body {
            padding: 0;
            width: 100%;
            height: calc(100% - 60px);
        }
    }
}
</style>
